import React from 'react';

import { useDisclosure } from '@chakra-ui/react';

import { WorkflowIcon } from 'components/Icons';
import { ActiveWorkflows } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/ActiveWorkflows';
import { BlueprintDetailCard } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/BlueprintDetailCard';

export const Workflows: React.FC = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  return (
    <>
      <BlueprintDetailCard
        icon={<WorkflowIcon p={0.5} />}
        label="Workflows"
        onClick={() => onOpen()}
      />
      {isOpen && <ActiveWorkflows isOpen={isOpen} onClose={onClose} />}
    </>
  );
};
